import axios from "axios";
import { getValidToken } from "../../../utils/authUtils";

export const categoryApi = {
  addCategory: async (data: any) => {
    try {
      const token = await getValidToken();
      const response = await axios.post(
        `${process.env.REACT_APP_API_HOST}inventory/category`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.data?.isSuccess) {
        return true;
      }
      throw new Error(response?.data?.message);
    } catch (error) {
      throw error;
    }
  },
  getCategories: async () => {
    try {
      const token = await getValidToken();
      const response = await axios.get(
        `${process.env.REACT_APP_API_HOST}inventory/category`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      }
      throw new Error(response?.data?.message);
    } catch (error) {
      return [];
    }
  },
};

export const inventoryApi = {
  getInventoryItems: async (categoryId: string) => {
    try {
      const token = await getValidToken();
      const response = await axios.get(
        `${process.env.REACT_APP_API_HOST}inventory/items/${categoryId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      }
      throw new Error(response?.data?.message);
    } catch (error) {
      return [];
    }
  },
  createInventoryItems: async (data: any) => {
    try {
      const token = await getValidToken();
      const response = await axios.post(
        `${process.env.REACT_APP_API_HOST}inventory/items`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      }
      throw new Error(response?.data?.message);
    } catch (error) {
      throw error;
    }
  },

  allocateItem: async (data: any) => {
    try {
      const token = await getValidToken();
      const response = await axios.post(
        `${process.env.REACT_APP_API_HOST}inventory/allocate`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      }
      throw new Error(response?.data?.message);
    } catch (error) {
      throw error;
    }
  },
  reallocateItem: async (data: any) => {
    try {
      const token = await getValidToken();
      const response = await axios.post(
        `${process.env.REACT_APP_API_HOST}inventory/reallocate`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      }
      throw new Error(response?.data?.message);
    } catch (error) {
      throw error;
    }
  },
  unallocateItem: async (masterAllocationId: string) => {
    try {
      const token = await getValidToken();
      const response = await axios.delete(
        `${process.env.REACT_APP_API_HOST}inventory/unallocate/${masterAllocationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      }
      throw new Error(response?.data?.message);
    } catch (error) {
      throw error;
    }
  },
};
